import type { FormInstance } from 'antd';
import { useCallback } from 'react';

import {
  applyReorderedSection,
  withAlwaysIncludedActivityPriority,
  withHotelPriority,
  withRoomPriority,
} from '../_components/_utils/priorityUtils';
import type {
  HotelActivity,
  HotelPackage,
  HotelRoom,
  PackagesRoomsAmenitiesFormValues,
} from '../_types';

type Props = {
  form: FormInstance<PackagesRoomsAmenitiesFormValues>;
  packages: HotelPackage[];
  activities: HotelActivity[];
};

export const useEntityReorder = ({ form, packages, activities }: Props) => {
  const handleReorderPackages = useCallback(
    (_sectionKey: string, reorderedItems: HotelPackage[]) => {
      const reordered = applyReorderedSection(packages, reorderedItems);

      form.setFieldValue('packages', withHotelPriority(reordered));
    },
    [form, packages]
  );

  const handleReorderRooms = useCallback(
    (_sectionKey: string, reorderedItems: HotelRoom[]) => {
      form.setFieldValue('rooms', withRoomPriority(reorderedItems));
    },
    [form]
  );

  const handleReorderActivities = useCallback(
    (_sectionKey: string, reorderedItems: HotelActivity[]) => {
      const reordered = applyReorderedSection(activities, reorderedItems);

      form.setFieldValue(
        'activities',
        withAlwaysIncludedActivityPriority(reordered)
      );
    },
    [activities, form]
  );

  return { handleReorderPackages, handleReorderRooms, handleReorderActivities };
};
